@use "../../../../styles/text";

:host {
  display: flex;
  min-height: var(--text-body-line-height-sm);
  align-items: flex-start;
  column-gap: var(--spacing-xs);
  margin-bottom: var(--spacing-xxs);

  ::slotted(label) {
    color: var(--color-text-base);
    @include text.text-body-sm;
    min-height: var(--text-body-line-height-sm);
  }

  ::slotted(input[type="radio"]) {
    height: var(--text-body-line-height-sm);
    flex: 0 0 auto;
  }
}

:host(:last-of-type) {
  margin-bottom: 0;
}
